import React, { useContext, useState } from "react";
import { Form } from "react-daisyui";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Context/AuthProvider/AuthProvider";
import ShowReview from "./ShowReview";

const ServiceReview = ({ serviceDet }) => {
  const { user } = useContext(AuthContext);
  const { _id,title,photo } = serviceDet;
console.log(serviceDet);
  const [reviewDetail, setReviewDetail] = useState({
    name: `${user?.displayName}`,
    photo: `${user?.photoURL}`,
    uid: `${user?.uid}`,
    serviceName:`${title}`,
    servicePhoto:`${photo}`
  });
  const handleSubmitReview = (e) => {
    e.preventDefault();

    fetch(`https://spooky-journalist-server.vercel.app/reviews/`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(reviewDetail),
    })
      .then((res) => res.json())
      .then((data) => {
        e.target.reset();
        console.log(data);
      });
    // window.location.reload();
  };
  const handleReviewChange = (e) => {
    e.preventDefault();
    const serviceId = serviceDet._id;
    const writenReview = e.target.value;
    const newReviewDetail = { ...reviewDetail, writenReview, serviceId };
    setReviewDetail(newReviewDetail);
    // console.log(writenReview);
    // console.log(reviewDetail);
  };
  // console.log(reviewDetail);
  // console.log(user.displayName);
  return (
    <div>
      <div className="card md:w-1/2 bg-base-100 shadow-xl mx-auto my-10">
        <div className="card-body">
          <h2 className="card-title">Write a Review!</h2>
          {user?.uid ? (
            <p></p>
          ) : (
            <p className="text-red-400">
              {" "}
              * Please{" "}
              <span className="text-green-600">
                <Link to="/login">login</Link>
              </span>{" "}
              before writting a review
            </p>
          )}
          <Form onSubmit={handleSubmitReview}>
            <textarea
              name="review"
              onBlur={handleReviewChange}
              className="textarea textarea-success h-36"
              placeholder="Write a review here..."
            ></textarea>
            <div className="card-actions justify-end my-5">
              {user?.uid ? (
                <button className="btn btn-primary">Post Review</button>
              ) : (
                <button disabled className="btn btn-primary ">
                  Post Review
                </button>
              )}
            </div> 
          </Form>
        </div>
      </div>
      <ShowReview > </ShowReview>
    </div>
  );
};

export default ServiceReview;
